module.exports = __webpack_public_path__ + "static/favicon.4cf21fc3.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 455
// module chunks = 114276838955818